var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "grid-row" }, [
    _c("div", { staticClass: "row-name", attrs: { title: _vm.row.name } }, [
      _vm._v("\n    " + _vm._s(_vm.row.displayName) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row-default-binding row-binding",
        class: {
          overwritten: _vm.isOverwrittern(
            _vm.presets[_vm.selectedPreset],
            _vm.customKeyBindings
          ),
          "not-set": _vm.presetBase[_vm.row.name] === undefined,
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.showReadonlyKey(_vm.presetBase)) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row-preset-binding row-binding",
        class: {
          overwritten: _vm.isOverwrittern(_vm.customKeyBindings),
          "not-set":
            _vm.presets[_vm.selectedPreset][_vm.row.name] === undefined,
        },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.showReadonlyKey(_vm.presets[_vm.selectedPreset])) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row-custom-binding row-binding" }, [
      _vm.editable
        ? _c(
            "div",
            { staticClass: "custom-binding-edit" },
            [
              _c("TextBox", {
                ref: "customBindingTextBox",
                attrs: {
                  placeholder: "禁用",
                  "change-on-blur": "",
                  text: _vm.customKeyBindings[_vm.row.name],
                },
                on: { change: _vm.updateCustomBinding },
              }),
              _vm._v(" "),
              _c(
                "VButton",
                {
                  attrs: { type: "transparent", title: "删除自定义键位" },
                  on: {
                    click: function ($event) {
                      return _vm.removeCustomBinding()
                    },
                  },
                },
                [
                  _c("VIcon", {
                    attrs: { icon: "mdi-trash-can-outline", size: 16 },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "custom-binding-add" },
            [
              _c(
                "VButton",
                {
                  attrs: { type: "transparent", title: "添加自定义键位" },
                  on: {
                    click: function ($event) {
                      return _vm.addCustomBinding()
                    },
                  },
                },
                [_c("VIcon", { attrs: { icon: "mdi-plus", size: 16 } })],
                1
              ),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }